import { React, Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PolicyLookupSpinner } from "../../../PolicyLookupSpinner";
import { apiGetAppConfig, apiGetPolicyInfo, apiSetDeflected } from "utils/API/TrxNowAPI";
import "./ARIMemberInformationForm.scss";
import { ARIConfirmMileageExceededModal } from "../ARIConfirmMileageExceededModal";
//import { ConfirmNoCoverageModal } from "../ConfirmNoCoverageModal";
//import { ConfirmMileageExceededModal } from "../ConfirmMileageExceededModal";
import { devLog } from "utils/devLog";

const policyMap = new Map();

export default function ARIMemberInformationForm(props) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.VIN);

  const [searchValueLN, setSearchValueLN] = useState(props.currState.MemberLookup.VIN);

  const [valueOdometer, setValueOdometer] = useState(props.currState.MemberLookup.Odometer);

  const [valueLicensePlate, setValueLicensePlate] = useState(props.currState.MemberLookup.LicensePlate);

  const [valueProvinceCode, setValueProvinceCode] = useState(props.currState.MemberLookup.ProvinceCode);

  const [valueClientId, setValueClientId] = useState(props.currState.MemberLookup.ClientID);

  const [valueUnitNo, setValueUnitNo] = useState(props.currState.MemberLookup.UnitNo);
  const [valueServiceCardNum, setValueServiceCardNum] = useState(props.currState.MemberLookup.ServiceCardNum);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.SearchType);

  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  const [contractData, setContractData] = useState(undefined);
  const [selectedVehicle, setSelectedVehicle] = useState(undefined);

  const [showDeflectionModal, setShowDeflectionModal] = useState(false);

  useEffect(() => {
    // devLog(props);
    onSubmit();
  }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    // devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      setContractData(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        firstName: props.currState.FirstName,
        lastName: props.currState.LastName,
        phone: props.currState.Number,
        searchType: searchType,
        vin: searchValue,
        licensePlate: valueLicensePlate,
        provinceCode: valueProvinceCode,
        odometer: valueOdometer,
        clientId: valueClientId,
        unitNo: valueUnitNo,
        partnerCode: partnerCode,
        serviceCardNumber: valueServiceCardNum,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        // devLog("JSON", json);
        if (typeof json.data.memberInfo === "object") {
          setContractData(json.data.memberInfo);
          if (json.data.error) {
            setError(json.data.error.message);
            onLoad(false);
          } else {
            //check to see if the vehicles array is empty.
            //if the vehicle array is empty onLoad(false);
            //if the vehicle array is not empty onLoad(true);
            if (json.data.memberInfo.vehicles.length) {
              policyMap.set(searchValue, json.data.memberInfo);
              onLoad(true);
            } else {
              onLoad(false);
              setContractData(undefined);
              setError("Unable to locate member information");
              onLoad(false);
            }
          }
        } else if (typeof json.data.error === "object") {
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setError("Unable to process account lookup!");
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      });
  };

  const onSelect = (vehicle) => {
    devLog("onSelect", vehicle);
    setSelectedVehicle(vehicle);

    if (!vehicle) {
      return;
    }

    // let forceWarranty = true;
    // if (
    //   (vehicle.warranty.length &&
    //     vehicle.warranty[0].odometer > valueOdometer) ||
    //   forceWarranty
    // )
    if (contractData.isDisableDeflectionBypass && vehicle.warranty[0].withinWarranty) {
      setShowDeflectionModal(true);
    } else if (
      !contractData.isWarrantyException &&
      vehicle.warranty.length &&
      vehicle.warranty[0].withinWarranty &&
      vehicle.warranty[0].odometer > valueOdometer
    ) {
      // if (vehicle.warranty.odometer > valueOdometer)
      setShowDeflectionModal(true);
      return;
    }

    if (typeof props.onSelect === "function") {
      props.onSelect(
        contractData,
        vehicle,
        contractData.isDisableDeflectionBypass && vehicle.warranty[0].withinWarranty,
      );
    }
  };

  const onUserBack = (e) => {
    e.preventDefault();
    setShowDeflectionModal(false);
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  /**
   * User wants to override the deflection
   */
  const onOverrideDeflection = () => {
    setShowDeflectionModal(false);
    props.context.setState(
      {
        deflectionOverride: true,
      },
      () => {
        if (typeof props.onSelect === "function") {
          props.onSelect(contractData, selectedVehicle);
        }
      },
    );
  };

  /**
   * User wants to cancel their service
   */

  const onUserDeflection = () => {
    setShowDeflectionModal(false);
    props.context.setState(
      {
        deflectionOverride: false,
      },
      () => {
        if (typeof props.onSelect === "function") {
          props.onSelect(contractData, selectedVehicle);
        }
        if (typeof props.onUserCancel === "function") {
          props.onUserCancel({
            deflection: true,
            deflectionInfo: {
              contractData: contractData,
              selectedVehicle: selectedVehicle,
              odometer: valueOdometer,
            },
          });
        }
      },
    );
  };
  // const onUserDeflection = () => {
  //   setShowDeflectionModal(false);

  //   const c_selectedVehicle = selectedVehicle;
  //   props.context.setState(
  //     {
  //       deflectionOverride: false,
  //     },
  //     () => {
  //       setSelectedVehicle(undefined);
  //       try {
  //         if (typeof props.onSelect === "function") {
  //           props.onSelect(contractData, undefined);
  //         }
  //       } catch (e) {
  //         console.error(e);
  //       }

  //       if (typeof props.onUserCancel === "function") {
  //         props.onUserCancel();
  //       }

  //       try {
  //         apiSetDeflected({
  //           data: {
  //             providerRef: props.currState.providerRef,
  //             memberInfo: contractData,
  //             vehicle: c_selectedVehicle,
  //             odometer: valueOdometer,
  //           },
  //           companyParams: props.currState.currentCompanyParams,
  //         });
  //       } catch (e) {
  //         console.error(e);
  //       }
  //     }
  //   );
  // };

  return (
    <>
      <div className="formContainer">
        {contractData ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.ConfirmCustomerName")}:</b> {contractData.clientName}
              </div>
            </div>
            <div className="vehicleHeader">
              <h4 className="slim">{t("description.ContractInformationHeader3")}</h4>
            </div>
            <div className="vehicle-list-container">
              <>
                {contractData.vehicles.map((item, index) => {
                  return (
                    <div
                      key={index}
                      value={item}
                      className={`vehicle-list-item ${selectedVehicle === item ? "selected" : ""}`}
                      onClick={(e) => {
                        onSelect(item);
                      }}
                    >
                      <div value={item} className="vehicle-list-item-col-1">
                        <h5 value={item}>
                          {item.make} {item.model} {item.year}
                        </h5>
                      </div>
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="policy-vehicle"
                        checked={selectedVehicle === item ? "selected" : ""}
                      />
                    </div>
                  );
                })}
              </>
            </div>
            <ARIConfirmMileageExceededModal
              isOpen={showDeflectionModal}
              logo={props.currState.localGroupLogo}
              onYes={onUserDeflection}
              onNo={onOverrideDeflection}
              isDisableDeflectionBypass={contractData.isDisableDeflectionBypass}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleARI`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}
